import { Question } from '../question';

export class OpenAudioQuestion extends Question {}
